module.exports = __webpack_public_path__ + "static/media/slackImage.59c5459a.png";